import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;


const HeaderClient = ({titre, setAjoutClient}) => {
   


    return (
      <div className="p-2">
        <div
          className="flex flex-column md:flex-row justify-content-between md:align-items-end mb-4"
          style={{ paddingBottom: "10px" }}
        >
          <div className="mb-3 md:mb-0">
            <h2
              className="m-0"
              style={{
                fontSize: "1.6rem",
                fontWeight: "700",
                letterSpacing: "-0.5px",
              }}
            >
               {titre}
            </h2>
          </div>

          <Button
            label="Nouveau client"
            icon="pi pi-plus"
            onClick={() => setAjoutClient(true)}
            className="w-full md:w-auto"
            style={{
              backgroundColor: "#0971b7",
              border: "none",
              color: "#ffffff",
              fontSize: "0.8rem",
              fontWeight: "700",
              borderRadius: "8px",
              padding: "10px 18px",
            }}
          />
        </div>
      </div>
    );
};

export default HeaderClient;